
<div *ngIf="tooltipBehavior === 'hover'" class="winoTooltip--{{tooltipTheme}} winoTooltip--{{tooltipTheme}}--{{tooltipPosition}} fs-5" [style.left]="absoluteHorizontalPosition + 'px'" [style.top]="absoluteVerticalPosition + 'px'" [style.max-width]="tooltipWidth + 'px'" [style.min-width]="tooltipWidth + 'px'">
    <div *ngIf="tooltipText?.length > 0" class="text-center">
        <span>{{tooltipText}}</span>
    </div>
    <div *ngIf="tooltipSecondaryText?.length > 0">
        <span class="fs-6 winoTooltip--secondaryText" [style.color]="tooltipTheme === 'dark' ? 'rgba(255, 255, 255, 0.800)' : '#b6a1e9'">{{tooltipSecondaryText}}</span>
    </div>
</div>

<div *ngIf="tooltipBehavior === 'dynamic'" class="winoTooltip--{{tooltipBehavior}}">
    <span>{{mouseHorizontalPosition}} x {{mouseVerticalPosition}}</span>
</div>
